import $ from "jquery";
import CONFIG from "@bd-core/config";
import bdapi from "@bd-core/bd-api";
import { getState } from "@bd-stores/store";
import { updateAttributes } from "@bd-core/firebase-actions";
import { setShouldFinishAt } from "@bd-stores/game-progress";

export default class Timer {
    constructor(timeoutCallback) {
        this.timeoutCursor = null;
        this.timeoutCallback = timeoutCallback;
        this.remainingTime = null;
        this.isPaused = false;
        this.pausedAt = null;
        this.timeLeft = null;
        this.elms = {
            timer: ".js-timer-text",
            timerRemaining: ".js-timer-remaining",
            popupHint: ".js-popup-timerhint",
        };
        this.timerWarningDuration = 2000;
        this.timerWarningClass = "timer-warning";
    }

    init() {
        if (!CONFIG.game.cfgLimit) return false;

        const $popup = $(this.elms.popupHint);
        $popup.find(".js-close-hint").on("click", this.hideNotif.bind(this));

        if (this.timeoutCursor) {
            clearInterval(this.timeoutCursor);
        }

        const gameProgress = getState().gameProgress;
        const cfgLimitInMinutes = CONFIG.game.cfgLimit.timeLimit * 60;
        const timeLeft =
            gameProgress.shouldFinishAt - Math.floor(Date.now() / 1000);

        if (timeLeft <= 0) {
            this.updateTimer("00", "00", "00", "100");
            return false;
        }

        if (CONFIG.game.isFinish || CONFIG.game?.game_prop?.disableTimer) {
            const objTime = this.toTimeObject(timeLeft);
            const percentage = (100 * timeLeft) / cfgLimitInMinutes;

            this.updateTimer(objTime.h, objTime.m, objTime.s, percentage);

            return false;
        }

        this.timeoutCursor = setInterval(() => {
            const shouldFinishAt = getState().gameProgress.shouldFinishAt;
            const time = shouldFinishAt - Math.floor(Date.now() / 1000);
            const percentage = (100 * time) / cfgLimitInMinutes;
            const objTimer = this.toTimeObject(time);

            $.each(CONFIG.game.cfgLimit.notifications, (index, item) => {
                const hours = Math.floor(item.inMinutesLeft / 60)
                    .toString()
                    .padStart(2, "0");
                const minutes = Math.floor(item.inMinutesLeft % 60)
                    .toString()
                    .padStart(2, "0");

                if (
                    objTimer.h == hours &&
                    minutes == objTimer.m &&
                    objTimer.s == "00"
                ) {
                    this.showNotif(item.title, item.text);
                    CONFIG.game.cfgLimit.notifications.splice(index, 1);
                    return false;
                }
            });

            this.updateTimer(objTimer.h, objTimer.m, objTimer.s, percentage);

            if (time <= 0) {
                clearInterval(this.timeoutCursor);

                if (typeof this.timeoutCallback === "function")
                    this.timeoutCallback();
            }
        }, 1000);

        const time =
            gameProgress.shouldFinishAt - Math.floor(Date.now() / 1000);
        const objTimer = this.toTimeObject(time);
        const percentage = (100 * time) / cfgLimitInMinutes;
        this.updateTimer(objTimer.h, objTimer.m, objTimer.s, percentage);

        return this;
    }

    toTimeObject(time) {
        const hours = Math.floor((time / (60 * 60)) % 24);
        const minutes = Math.floor((time / 60) % 60);
        const seconds = Math.floor(time % 60);

        return {
            h: hours.toString().padStart(2, "0"),
            m: minutes.toString().padStart(2, "0"),
            s: seconds.toString().padStart(2, "0"),
        };
    }

    updateTimer(h, m, s, percent) {
        if (this.isPaused) return false;
        let scnd = `<span class="minute">${m}</span><span class="second">${s}</span>`;
        percent = percent < 0 ? 0 : percent;
        percent = Math.floor(percent);

        if (percent < 20) {
            $(".js-timer").addClass("is-almost-end");
        }

        $(this.elms.timer).html(scnd);
        $(this.elms.timerRemaining).css("--p", percent);
    }

    start() {
        this.isPaused = false;
        this.init();
    }

    showNotif(title, text) {
        const $popup = $(this.elms.popupHint);

        $popup.find(".js-hint-title").text(title);
        $popup.find(".js-hint-content").html(text);
        $popup.addClass("is-open");
    }

    hideNotif() {
        const $popup = $(this.elms.popupHint);
        $popup.removeClass("is-open is-feedback");
    }

    stopTimer() {
        if (CONFIG.game.isFinish) {
            clearInterval(this.timeoutCursor);
        }
    }

    pauseTimer() {
        if (!this.isPaused) {
            this.isPaused = true;
            this.pausedAt = this.remainingTime;
            this.timeLeft = CONFIG.game.timeLeft;

            clearInterval(this.timeoutCursor);
            $(".js-timer").addClass("is-paused");
            bdapi.post("game/update-timeleft", {
                timeLeft: this.timeLeft,
            });
            this.init();
        }
    }

    continueTimer() {
        if (this.isPaused) {
            this.isPaused = false;
            this.remainingTime = this.pausedAt;
            CONFIG.game.timeLeft = this.timeLeft;
            $(".js-timer").removeClass("is-paused");
        }
    }

    /**
     * Applies time penalty by updating the timer and showing visual feedback
     * @param {number} timeRisk - The time penalty to apply
     */
    applyTimePenalty(timeRisk) {
        if (timeRisk === 0) return;
        const shouldFinishAt = getState().gameProgress.shouldFinishAt;
        const updatedTime = shouldFinishAt - timeRisk;

        this.showTimerWarning();

        const objTime = this.toTimeObject(updatedTime);
        const percentage =
            ((100 * updatedTime) / CONFIG.game.cfgLimit.timeLimit) * 60;
        this.updateTimer(objTime.h, objTime.m, objTime.s, percentage);

        setShouldFinishAt(updatedTime);
        updateAttributes({ shouldFinishAt: updatedTime });
    }

    /**
     * Shows visual warning on the timer and removes it after a delay
     */
    showTimerWarning() {
        const $timer = $(".js-timer");

        $timer.addClass("is-almost-end");
        $(".timer__clock").addClass(this.timerWarningClass);

        setTimeout(() => {
            $timer.removeClass("is-almost-end");
            $(".timer__clock").removeClass(this.timerWarningClass);
        }, this.timerWarningDuration);
    }

    timeLeftToSeconds(shouldFinishAt, finishedAt) {
        const timeDiff = shouldFinishAt - finishedAt;
        const timeLimit = (CONFIG?.game?.cfgLimit?.timeLimit ?? 20) * 60;

        if (timeDiff > timeLimit) {
            return "00:00";
        }

        const minutes = Math.floor(timeDiff / 60);
        const seconds = Math.floor(timeDiff % 60);

        return `${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`;
    }
}
